export default __webpack_public_path__ + "static/media/bronze.ca35bf30.png";